import { Controller } from '@hotwired/stimulus'

const BODY_CLASS = 'sf-body__modal-open'

export default class extends Controller {
  private observer: MutationObserver | null = null

  connect(): void {
    this.observer = new MutationObserver(() => this.sync())
    this.observer.observe(this.element, {
      attributes: true,
      attributeFilter: ['style', 'aria-hidden'],
    })
    this.sync()
  }

  disconnect(): void {
    this.observer?.disconnect()
    this.observer = null
    this.unlock()
  }

  private sync = (): void => {
    if (this.hidden()) {
      this.unlock()
    } else {
      this.lock()
    }
  }

  private hidden(): boolean {
    const element = this.element as HTMLElement

    return (
      element.style.display === 'none' ||
      element.getAttribute('aria-hidden') === 'true'
    )
  }

  private lock(): void {
    document.body.classList.add(BODY_CLASS)
  }

  private unlock(): void {
    document.body.classList.remove(BODY_CLASS)
  }
}
